throw new Error(
  '@web-widget/inspector has been moved to @web-widget/inspector package. Please update your imports.'
);
